module.exports = __webpack_public_path__ + "static/media/bank.a7787dbd.svg";